import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dialog: {
    maxWidth: 480
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4)
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  subtitle: {
    marginBottom: theme.spacing(4)
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  notification: {
    marginTop: theme.spacing(3)
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4)
  }
}));
